// extracted by mini-css-extract-plugin
export default {"skeletonLoader":"DiagramLineSkeletonLoader_skeletonLoader__ERp0W"};